module.exports = __webpack_public_path__ + "img/pnu_main1.e5af9bd9.jpg";